import axios from 'axios';
import React, { Component } from 'react';
import { ApiUrl } from '../services/ApiRest';
import Cookies from 'universal-cookie';
import {
    NavLink as Link,
    withRouter
} from 'react-router-dom';

const urlEstudiante = ApiUrl + "estudiantes/";
const urlIdPeriodoActual = ApiUrl + "periodos" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlCarrerasMatrUltCiclo = ApiUrl + "carrerasmatriultimociclo" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlPeriodosCreditosExtra = ApiUrl + "periodos-creditos-extra-estudiante" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlVerificarAsignadasEst = ApiUrl + "verificar-horas-practicas-est" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";

const cookie = new Cookies();
const idEstudiante = cookie.get("idEstudiante");    //declaramos una variable para usar la cookie del login

class SidebarEstudiante extends Component {

    componentDidMount() {
        // Get que devuelve los datos de un estudiante recibiendo un id
        axios.get(urlEstudiante + idEstudiante + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71")
            .then(res => {
                const estudiante = res.data[1];
                this.setState({ estudiante });
                var segundoApellido = "";
                var segundoNombre = "";

                if (estudiante.segundo_apellido_estudiante != null)
                    segundoApellido = estudiante.segundo_apellido_estudiante;

                if (estudiante.segundo_nombre_estudiante != null)
                    segundoNombre = estudiante.segundo_nombre_estudiante;

                var NombresCompleto = estudiante.primer_nombre_estudiante + " " + segundoNombre;
                var ApellidosCompletos = estudiante.primer_apellido_estudiante + " " + segundoApellido;

                cookie.set('nombres', NombresCompleto, { path: "/" })
                cookie.set('apellidos', ApellidosCompletos, { path: "/" })
            })

        //CONSULTAR EL PERIODO  ACTUAL
        axios.get(urlIdPeriodoActual)
            .then(respuesta => {
                const periodosId = respuesta.data.id_periodo_academico;
                cookie.set('idperiodoActual', periodosId, { path: "/" })
            })
        //Consultar si el estudiante cursa el último nivel de una carreras para habilitar la opción de titulación
        axios
            .post(urlCarrerasMatrUltCiclo, {
                idEstudiante: cookie.get("idEstudiante")
            })
            .then(response => {
                if (response.data.success != true) {
                    document.getElementById('divTitulacion1').style.visibility = 'hidden';
                }
            })

        axios.get(urlPeriodosCreditosExtra, {
            params: {
                idEstudiante: cookie.get("idEstudiante"),
            }
        })
            .then(response => {
                if (response.data.success !== true || response.data.data.length === 0) {
                    // Oculta el enlace si no hay periodos con créditos extra
                    const divCreditos = document.getElementById("divCreditosExtra");
                    if (divCreditos) divCreditos.style.display = "none";
                }
            })
            .catch(error => {
                console.error("Error consultando créditos extra:", error);
                const divCreditos = document.getElementById("divCreditosExtra");
                if (divCreditos) divCreditos.style.display = "none";
            });

        axios.get(urlVerificarAsignadasEst, {
            params: {
                idEstudiante: cookie.get("idEstudiante"),
            }
        })
            .then(response => {
                if (response.data.success !== true) {
                    // Oculta el enlace si el estudiante no tiene horas de práctica asignadas
                    const divPracticas = document.getElementById("divPracticas");
                    if (divPracticas) divPracticas.style.display = "none";
                }
            })
            .catch(error => {
                console.error("Error consultando créditos extra:", error);
                const divPracticas = document.getElementById("divPracticas");
                if (divPracticas) divPracticas.style.display = "none";
            });
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            document.body.classList.remove("sb-sidenav-toggled");
        }
    }
    render() {
        return (
            <div id="layoutSidenav_nav" style={{ width: 226 }}>
                <nav
                    className="sb-sidenav sb-sidenav-dark-custom accordion animate__animated animate__fadeInLeft"
                    id="sidenavAccordion"
                >
                    <div className="sb-sidenav-menu px-2 pt-3">
                        <div className="sb-sidenav-menu-heading text-uppercase text-muted small mb-2">
                            <p className="text-white">Estudiante ISTMAS</p>
                        </div>

                        <Link to="/estudiante" className="nav-link-custom">
                            <i className="fas fa-home me-2"></i>
                            Página Principal
                        </Link>

                        {/* Mi Perfil */}
                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsePerfilEst"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="far fa-user me-2"></i>
                                    Mi Perfil
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapsePerfilEst">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/estudiante/EstudianteVerPerfil" className="nav-sub-link">
                                        Ver Perfil
                                    </Link>
                                </nav>
                            </div>
                        </div>

                        {/* Matrículas */}
                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseMatriculasEst"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="fas fa-dollar-sign me-2"></i>
                                    Matrículas
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapseMatriculasEst">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/estudiante/EstudianteInscrip" className="nav-sub-link">
                                        Inscripción pago matrícula
                                    </Link>
                                </nav>
                            </div>
                        </div>

                        {/* Asignaturas */}
                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseAsignaturasEst"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="fas fa-graduation-cap me-2"></i>
                                    Asignaturas
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapseAsignaturasEst">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/estudiante/ListarAsignaturasMatricu" className="nav-sub-link">
                                        Asignaturas Matriculadas
                                    </Link>
                                    <Link to="/estudiante/ListarCreditosExtraMatricu" className="nav-sub-link" id="divCreditosExtra">
                                        Créditos Extra Matriculados
                                    </Link>
                                </nav>
                            </div>
                        </div>

                        {/* Pagos Colegiaturas */}
                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsePagosColegiaturas"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="fas fa-dollar-sign me-2"></i>
                                    Pagos Colegiaturas
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapsePagosColegiaturas">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/estudiante/EstudianteColegPeriodCarr" className="nav-sub-link">
                                        Pagos Colegiatura
                                    </Link>
                                </nav>
                            </div>
                        </div>

                        {/* Agenda */}
                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseAgendaEst"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="far fa-sticky-note me-2"></i>
                                    Agenda
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapseAgendaEst">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/estudiante/AgendaEst" className="nav-sub-link">
                                        Ver Agenda
                                    </Link>
                                </nav>
                            </div>
                        </div>

                        {/* Notificaciones */}
                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseNotificacionesEst"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="far fa-bell me-2"></i>
                                    Notificaciones
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapseNotificacionesEst">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/estudiante/NotificacionEstudiante" className="nav-sub-link">
                                        Ver Notificaciones
                                    </Link>
                                </nav>
                            </div>
                        </div>

                        {/* Documentación */}
                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseDocumentacionEst"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="fa fa-folder me-2"></i>
                                    Documentación
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapseDocumentacionEst">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/estudiante/actadecompromiso" className="nav-sub-link">
                                        Acta de compromiso
                                    </Link>
                                </nav>
                            </div>
                        </div>

                        {/* Prácticas */}
                        <div id="divPracticas" className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsePracticasEst"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="fas fa-graduation-cap me-2"></i>
                                    Prácticas
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapsePracticasEst">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/estudiante/ListPracticasLaborales" className="nav-sub-link">
                                        Prácticas Laborales
                                    </Link>
                                </nav>
                            </div>
                        </div>

                        {/* Titulación */}
                        <div className="nav-section">
                            <div id="divTitulacion1"
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseTitulacionEst"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="fas fa-graduation-cap me-2"></i>
                                    Titulación
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapseTitulacionEst">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/estudiante/tipostitulacion" className="nav-sub-link">
                                        Tipos de titulación
                                    </Link>
                                </nav>
                            </div>
                        </div>
                    </div>

                    <div className="sb-sidenav-footer text-white bg-azul-light text-center py-3 small">
                        Usuario:<br />
                        {cookie.get("nombres")} {cookie.get("apellidos")}
                    </div>
                </nav>
            </div>
        )
    }
}

export default withRouter(SidebarEstudiante);